class FeaturedAddOnsRecap extends HTMLElement {
  constructor() {
    super();
    this.moneyFormat = this.dataset.moneyFormat;
    this.subtotal = this.querySelector("#featured_add_ons_recap");
    this.hiddenInput = this.querySelector('input[name="contact[total add ons]"]');
    this.hiddenAddOnsInput = this.querySelector('input[name="contact[add ons]"]');
    this.sumOutput = document.querySelector("#total-add-ons");
    this.fearedAddOnsSubtotal = 0;
  }

  connectedCallback() {
    document.addEventListener("item-quantity-updated", this.handleQuantityChange.bind(this));
    this.fruechteboxGesamttotalElement = document.querySelector("fruechtebox-gesamttotal");
  }

  handleQuantityChange(e) {
    const { quantity, price, refId } = e.detail;

    if (quantity == 0) {
      const lineItem = document.querySelector(`#LineItem-${refId}`);
      if (lineItem) {
        lineItem.remove();
      }
    } else {
      const total = quantity * price;
      const subtotalPriceValueId = "Subtotal-PriceValue-" + refId;
      const subtotalPriceId = "Subtotal-Price-" + refId;
      const subtotalQuantityId = "Subtotal-Quantity" + refId;
      const subtotalTitleId = "Subtotal-CardLink" + refId;
  
      const alreadyCloned = document.querySelector(`#${subtotalQuantityId}`);
      if (!alreadyCloned) {
  
        const lineItem = document.createElement("div");
        lineItem.id = `LineItem-${refId}`;
        lineItem.classList.add("featured-add-on-line-item");
  
        const priceValueInput = document.querySelector(`#PriceValue-${refId}`);
        const clonesPriceValueInput = priceValueInput.cloneNode(true);
        clonesPriceValueInput.id = subtotalPriceValueId;
        lineItem.appendChild(clonesPriceValueInput);
  
        const originalQtyInput = document.querySelector(`#Quantity-${refId}`).closest("quantity-input");
        const clonedQtyInput = originalQtyInput.cloneNode(true);
        clonedQtyInput.querySelector(`#Quantity-${refId}`).id = subtotalQuantityId;
  
        originalQtyInput.querySelector("input").addEventListener('change', () => {
          clonedQtyInput.querySelector("input").value = originalQtyInput.querySelector("input").value;
        });
  
        clonedQtyInput.querySelector("input").addEventListener('change', () => {
          originalQtyInput.querySelector("input").value = clonedQtyInput.querySelector("input").value;
          originalQtyInput.querySelector("input").dispatchEvent(new Event("change", { bubbles: true }));
        });
  
        lineItem.appendChild(clonedQtyInput);
  
        const originalTitleElement = document.querySelector(`#CardLink-${refId}`);
        const clonedTitleElement = originalTitleElement.cloneNode(true);
        clonedTitleElement.id = subtotalTitleId;
        clonedTitleElement.classList.add("featured-add-on-line-item--title");
  
        lineItem.appendChild(clonedTitleElement);
  
        const originalPriceElement = document.querySelector(`#Price-${refId}`);
        const clonedPriceElement = originalPriceElement.cloneNode(true);
        clonedPriceElement.id = subtotalPriceId;
        clonedPriceElement.classList.add("add-on-subtotal-price");
  
        lineItem.appendChild(clonedPriceElement);
    
        this.subtotal.appendChild(lineItem);
      }
  
      const totalFormatted = this.moneyFormat.replace("{{amount}}", (total / 100).toFixed(2));
      
      document.querySelector(`#${subtotalPriceId}`).textContent = totalFormatted;
    }

    setTimeout(this.updateSubtotal.bind(this), 0);
    setTimeout(this.updateContactFormInfo.bind(this), 0);
  }

  updateSubtotal() {
      this.fearedAddOnsSubtotal = Array.from(document.querySelectorAll(".featured-add-on-line-item")).reduce(
      (accumulator, item) => {
        const quantityInput = item.querySelector('input[name="quantity"]');
        const priceInput = item.querySelector('input[name="price"]');

        const quantity = parseFloat(quantityInput?.value) || 0;
        const price = parseFloat(priceInput?.value) || 0;

        return accumulator + quantity * price;
      },
      0
    );

    const fearedAddOnsSubtotalFormatted = this.moneyFormat.replace("{{amount}}", (this.fearedAddOnsSubtotal / 100).toFixed(2));

    document.querySelector("#Featured-Add-Ons-Price .price-item").textContent = fearedAddOnsSubtotalFormatted;
    this.hiddenInput.value = fearedAddOnsSubtotalFormatted;
    this.sumOutput.textContent = fearedAddOnsSubtotalFormatted;

    this.fruechteboxGesamttotalElement.updateTotal();
  }

  updateContactFormInfo() {
    const addOnsEls = document.querySelectorAll(".featured-add-on-line-item");
    const addOns = [];
    addOnsEls.forEach(addOn => {
      const addOnTitle = addOn.querySelector(".featured-add-on-line-item--title").textContent.trim();
      const addOnQtyEl = addOn.querySelector("quantity-input input[name='quantity']");
      const addOnQty = parseFloat(addOnQtyEl?.value) || 0;
      const addOnInfo = `${addOnTitle} ${addOnQty}`.trim();
      addOns.push(addOnInfo);
    })

    this.hiddenAddOnsInput.value = addOns.join(', ');
  }
}

customElements.define('featured-add-ons-recap', FeaturedAddOnsRecap);
